import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import WallArtShop from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WallArtShop /> 
  </React.StrictMode>
);
